import { memo } from "react";
import classNames from "classnames";

import { ReactComponent as LoaderSVG } from "./icons/loaderVehicle.original.svg";

import styles from "./style.module.scss";

export type TecorienLoaderProps = {
  description?: string,
  progress?: number,
  className?: string
}

export const TecorienLoader = memo<TecorienLoaderProps>(({ className, progress, description }) => {

  return (
    <div className={classNames(styles.root, className)}>
      <span className={styles.description}>{
        [
          `${description || ""}`,
          `${progress !== undefined ? ` (${(progress * 100).toFixed()}%)` : ""}`,
        ].filter(x => x)
          .join(" ")
      }
      </span>
      <i className={styles.logo}>
        <LoaderSVG />
      </i>
    </div>
  );
});

export default TecorienLoader;
